<section class="seo-service">
    <div class="container-fluid">
        <div class="row center-align">
            <div class="col-md-6">
                <div class="service">
                    <h2 class="section-title">
                        تعريف عن كلمة الارشفة SEO!!
                    </h2>
                    <p>
                        سيو SEO هو علم "توافق" المواقع مع محركات البحث والمعروف ايضا بـ "Search engine optimization" وهو العلم الدائم التغير باستمرار مع التغير الدائم في قواعد عمل محركات البحث ويهدف السيو في الاساس الى الوصول بالمواقع لأفضل النتائج مع محركات البحث واستمرار ارشفتها داخل المواقع لاجتذاب المزيد من الزوار واكتساب ثقة وصداقة محركات البحث.
                    </p>
                    <p>
                        لماذا SEO، ؟ اذا كنت تبحث عن مزيد من الزوار لموقعك وتعزيز قوة موقعك فى محركات البحث ومتابعة نشاط موقعك يجب ان يكون لديك ادوات خاصة لموقعك لمعرفة ما هي الكلمات المفتاحية المستهدفة، وما هي قوة موقعك، وعدد الروابط الخلفية للموقع وما هو تقيم محركات البحث لموقعك، ومعرفة سرعة تحميل موقعك كل هذا واكثر توفره لك ولمعرفة المزيد من العروض المفيدة لموقعك انظر ادناه ..
                    </p>
                </div>
            </div>
            <div class="col-md-6 text-center">
                <img src="./../../../assets/images/what-is-seo.png" alt="seo" />
            </div>
        </div>
    </div>
</section>